import React from "react";
import { AuditOutlined, MailOutlined, WarningOutlined } from "@ant-design/icons";
import { normalizeCellSignals } from "./signalDisplay";

const SIGNAL_ICON = Object.freeze({
    mail: MailOutlined,
    review: AuditOutlined,
    alert: WarningOutlined,
});

function SignalBadge({ signals }) {
    const normalizedSignals = normalizeCellSignals(signals);
    if (normalizedSignals.length === 0) return null;

    return (
        <span className="grid-core-signal-badges" aria-label="cell signals">
            {normalizedSignals.map((signal) => {
                const Icon = SIGNAL_ICON[signal.type] || MailOutlined;
                return (
                    <span key={signal.type} className={`grid-core-signal-badge grid-core-signal-badge-${signal.type}`} title={`${signal.type}: ${signal.count}`}>
                        <Icon />
                        {signal.count > 1 && <span className="grid-core-signal-badge-count">{signal.count}</span>}
                    </span>
                );
            })}
        </span>
    );
}

export default SignalBadge;
